const BASE_URL = "https://a.klaviyo.com";
const LIST_ENDPOINT = "/client/subscriptions/";

class Klaviyo {
	constructor() {
		this.publicKey = window.klaviyo.key;
	}

	listSubscribe(email, listId) {
		const body = {
			data: {
				type: 'subscription',
				attributes: {
					profile: {
						data: {
							type: 'profile',
							attributes: { email }
						}
					}
				},
				relationships: { list: { data: { type: 'list', id: listId } } }
			}
		};

		return fetch(`${BASE_URL}${LIST_ENDPOINT}?company_id=${this.publicKey}`, {
			method: 'post',
			headers: {
				revision: '2024-02-15',
				'content-type': 'application/json'
			},
			body: JSON.stringify(body)
		});
	}
}
